import Util from './'

class Repeater
{
    static get SELECTOR_REPEATER() { return '[data-repeater]' }
    static get DATASET_REPEATER() { return 'repeater' }
    static get DATASET_REPEATER_INDEX() { return 'repeaterIndex' }

    constructor(el) {
        this.container = $(el)
        this.baseElement = this.getBaseElement()
    }

    /**
     * Initialise the repeater functionality.
     *
     * @return {void}
     */
    static init() {
        $(Repeater.SELECTOR_REPEATER).each(function () {
            const repeater = new Repeater(this)

            repeater.render()
        })
    }

    /**
     * Get the repeater index element selector, with or without an index.
     *
     * @param  {string|int|void}  index
     * @return {string}
     */
    static getIndexSelector(index) {
        return '[data-repeater-index' + ((index === undefined) ? ']' : ('="' + index + '"]'))
    }

    /**
     * Render control elements for the repeater.
     *
     * @return {void}
     */
    render() {
        const self = this

        this.container.find(Repeater.getIndexSelector())
            .each(function () {

                // Add the remove element to the existing elements.
                const id = this.dataset[Repeater.DATASET_REPEATER_INDEX]
                const removeEl = self.getRemoveElement(self.container, id)
                removeEl[0].dataset[Repeater.DATASET_REPEATER_INDEX] = id
                $(this).append(removeEl)
            })

        this.container.after(
            $('<button type="button" data-repeater-add>Add</button>')
                .on('click', function () {
                    const id = Util.uniqid()
                    const el = self.baseElement.clone()
                    const removeEl = self.getRemoveElement(self.container, id)

                    // Update the input array indexes.
                    el.find('[name]').each(function () {
                        this.name = this.name.replace(/\[0\]/, '[' + id + ']')
                        this.id = Util.uniqid(btoa(this.name))
                    })

                    // Add the remove element to the repeated element.
                    el[0].dataset[Repeater.DATASET_REPEATER_INDEX] = id
                    removeEl[0].dataset[Repeater.DATASET_REPEATER_INDEX] = id
                    el.append(removeEl)

                    self.container.append(el)
                })
        )
    }

    /**
     * Get the repeater instance base element.
     *
     * @return {object}
     */
    getBaseElement()
    {
        const el = this.container.children(Repeater.getIndexSelector(0))
            .clone(true)

        // Clear element values.
        el.find('input').val('')
        el.find('textarea').empty()

        return el
    }

    /**
     * Get the remove control element.
     *
     * @param  {object}  container
     * @param  {string}  id
     * @return {object}
     */
    getRemoveElement(container, id) {
        return $('<button type="button">Remove</button>')
            .on('click', function () {
                container.children(Repeater.getIndexSelector(id))
                    .remove()
            })
    }
}

export default Repeater
